import React from 'react';

import { Form, FormInstance } from '@ui-library/form';
import { FormConfig, FieldProps, FieldConfigMap } from '@api';

import { TextField, SelectField, SwitchField, TextAreaField } from './components';

interface LightFormBuilderProps {
  formConfig: FormConfig;
  form: FormInstance;
}

const fieldComponentMap = {
  textField: TextField,
  textAreaField: TextAreaField,
  selectField: SelectField,
  switchField: SwitchField,
} as const;

export const LightFormBuilder: React.FC<LightFormBuilderProps> = ({ form, formConfig }) => (
  <Form form={form} size="large" layout="vertical">
    {formConfig.fields.map((fieldConfig) => {
      const FieldComponent = fieldComponentMap[fieldConfig.component] as React.FC<
        FieldProps<keyof FieldConfigMap>
      >;

      return FieldComponent ? (
        <FieldComponent
          key={Array.isArray(fieldConfig.key) ? fieldConfig.key.join('.') : fieldConfig.key}
          fieldConfig={fieldConfig}
        />
      ) : null;
    })}
  </Form>
);
